import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilterableColumnLookupSelector, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { FaChevronDown, FaUserFriends, FaClock, FaChartLine, FaMagic, FaCalendarAlt, FaExclamationTriangle, FaDollarSign } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer, toast } from 'react-toastify';
import { formatShorthand, formatPhone } from '../../common/utils';
import LeadNamesInGrid from '../../containers/Loans/LeadNamesInGrid';
import { ModalCtx } from '../../contexts';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import { singleSelectQuickFilter } from '../../common/utils';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';
import NoteInGrid from '../Contacts/NoteInGrid';
import TaskInGrid from '../Contacts/TaskInGrid';
import Toolbar from './toolbar';
import TableMetric from '../../containers/Reports/metric';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';



const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const PQLoans = ( { aid, uid, user, grids, viewing, canExport, stack, loans, contacts, notes, tasks, status } ) => {
    const [ trx, setTrx ] = useState( 0 );
    const [ vol, setVol ] = useState( 0 );
    const [ rev, setRev ] = useState( 0 );
    const [ stages, setStages ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ pa, setPAs ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ dirty, setDirty ] = useState( false );
    const [ conversionRate, setConversionRate ] = useState( .1 );
    const [ variance, setVariance ] = useState( .025 );
    const [ conversionResults, setConversionResults ] = useState( { active: {}, funded: {} } );
    const [ conversionView, setConversionView ] = useState( 'active' );
    const [ pipelineMetrics, setPipelineMetrics ] = useState( [
        { label: 'Current Pre-Quals', value: 0, tooltip: 'Current # of Pre-Quals', icon: <FaUserFriends style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Avg Time as PQ', value: 0, tooltip: 'Average number of days pre-quals have been in this stage', icon: <FaClock style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Potential Volume', value: 0, tooltip: 'Potential purchase volume of all pre-quals', icon: <FaDollarSign style={{ color: '#ff7a59', marginRight: 8 }} /> }
    ] );
    const [ conversionMetrics, setConversionMetrics ] = useState( [
        { label: 'Successful Conversion %', value: 0, tooltip: 'Percentage of pre-quals that moved to In-Process over the past 180 days', icon: <FaChartLine style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Avg Time to Convert', value: 0, tooltip: 'Average time it took to convert successful pre-quals (past 180 days)', icon: <FaCalendarAlt style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Projected Conversions', value: 0, tooltip: `Expected conversion range based on a ${Math.round( conversionRate * 100 )}% historical conversion rate (+/- ${Math.round( variance * 100 )}%)`, icon: <FaMagic style={{ color: '#ff7a59', marginRight: 8 }} /> }
    ] );
    const [ riskMetrics, setRiskMetrics ] = useState( [
        { label: 'Stuck Pre-Quals', value: 'Coming Soon', tooltip: 'Current # of Pre-Quals', icon: <FaExclamationTriangle style={{ color: '#ff7a59', marginRight: 8 }} /> }
    ] );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const gridHelpers = {
        valueGetter: {
            borrowers: ( { row } ) => {
                let v = [];
                if ( row.borrowers && row.borrowers.length ) {
                    row.borrowers.forEach( b => {
                        const bor = contacts[b.cid];
                        if ( bor ) {
                            v.push( bor.name );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            phoneBorr: ( { row } ) => {
                let p;  
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneBA: ( { row } ) => {
                let p;  
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneLA: ( { row } ) => {
                let p;  
                if ( row.laId ) {
                    const c = contacts[row.laId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            emailBorr: ( { row } ) => {
                let e;
                if ( row.borrowers && row.borrowers.length ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailBA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailLA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            ooeBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutEmail ) {
                        oo = c.optoutEmail;
                    }
                }
                return ( oo );
            },
            oocBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutCall ) {
                        oo = c.optoutCall;
                    }
                }
                return ( oo );
            },
            oosBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutSms ) {
                        oo = c.optoutSms;
                    }
                }
                return ( oo );
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    if ( !value.match( 'T' ) ) {
                        d.setDate( d.getDate() + 1 );
                    }
                }
                return ( d ) ? d : null;
            },
            referral: ( { row } ) => {
                let n;
                if ( row.referredById ) {
                    n = formatName( row.referredById );
                }
                return n;
            },
            salesRep: ( { row } ) => {
                let n;
                if ( row.borrowers && row.borrowers.length ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c ) {
                        n = c.salesRepId;
                    }
                }
                return n;
            },
            latestClosedTask: ( { row } ) => {
                return row.lastTask;
            },
            latestNote: ( { row } ) => {
                return row.lastNote;
            }
        },
        renderCell: {
            loanname: ( params ) => <Link to={`/loan/${params.row.id}`}>{params.value}</Link>,
            borrowers: ( { row } ) => <LeadNamesInGrid row={row} />,
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { value } ) => {
                let l;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            referral: ( { row } ) => {
                let l;
                if ( row.referredById ) {
                    l = <Link to={`/contact/${row.referredById}`}>{ formatName( row.referredById ) }</Link>
                }
                return l;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            },
            latestClosedTask: ( { value } ) => {
                return <TaskInGrid task={value} />;
            },
            latestNote: ( { value } ) => {
                return <NoteInGrid note={value} />;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                let n;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        n = formatName( c.cid );
                    }
                }
                return n;
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            latestClosedTask: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            },
            latestNote: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
    
    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    const gridRef = useGridApiRef();

    const updateKPIs = ( model, details ) => {
        const visibleRows = gridFilteredSortedRowIdsSelector( gridRef );
        const rows = pa.filter( d => visibleRows.includes( d.lid ) );
        setTrx( rows.length );

        let v = 0;
        let rev = 0;
        rows.forEach( r => {
            let maxPrice = r.paMaxPurchPrice || r.maxPurchPrice || r.highPurchPrice || r.lowPurchPrice || r.purchasePrice || r.amount;
            if ( maxPrice ) {
                if ( typeof( maxPrice ) === 'string' ) {
                    maxPrice = maxPrice.replace( '$', '' );
                    maxPrice = maxPrice.replace( /,/g, '' );
                    maxPrice = maxPrice.replace( /\.\d\d/, '' );
                    maxPrice = Number( maxPrice );
                }
                v += maxPrice;
            }
            if ( r.revenue ) {
                let amt = r.revenue;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                rev += amt;
            }
        } );
        setVol( v );
        setRev( rev );
    }

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = async ( t ) => {
        let shouldOpen = true;

        const allCids = [];
        const allLids = [];
        const emailLids = [];
        const phoneLids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( lid => {
            const l = loans[lid];
            if ( l.borrowers?.length ) {
                let seenEmails = false;
                let seenPhones = false;

                allLids.push( lid );
                
                for ( const b of l.borrowers ) {
                    const c = contacts[b.cid];
                    if ( c ) {
                        if ( c.email && ( uniqueEmails.has( c.email.toLowerCase() ) || c.optoutEmail ) ) {
                            seenEmails = true;
                        }
                        let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                        if ( p && ( uniquePhones.has( formatPhone( p  ) ) || c.optoutSms ) ) {
                            seenPhones = true;
                        }
                    }
                }

                if ( !seenEmails ) {
                    emailLids.push( lid );
                }
                if ( !seenPhones ) {
                    phoneLids.push( lid );
                }
            }
        } );
        // console.log( 'cids: ', cids );
        
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} llist={emailLids} objType='loan' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} llist={phoneLids} objType='loan' /> );
                break;

            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='loans' items={allLids} aid={viewing[0]} /> );
                break;
    
            // case 'event':
            //     setModal( <AddEvent close={closeModal} contacts={contacts} /> );
            //     break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='loans' data={allLids} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    useEffect( () => {
        document.title = 'Third Floor - Pre-Qual\'d Borrowers';
    }, [] );
    
    useEffect( () => {
        let g;

        if ( grids && grids.pqs && grids.pqs.cols ) {
            g = grids.pqs.cols;
        } else if ( grids && grids.pas && grids.pas.cols ) {
            g = grids.pas.cols;
        }
        if ( g && !gridReady ) {
            const storedCols = JSON.parse( g );
            const cols = storedCols.map( c => {
                if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                    c.renderCell = gridHelpers.renderCell[c.renderCell];
                }
                if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                    c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                }
                if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                    c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                }
                if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                    c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                }
                return c;
            } );
            setCols( cols );
            setGridReady( true );
        }
    }, [ grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - numbersRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( loans ) {
            const stats = status.filter( s => s.queue === 'pq' ).map( m => m.value );
            let list = [];
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( stats.includes( l.status ) && l.borrowers?.length ) {
                    const pri = l.borrowers?.find( f => f.label === 'Primary' ) || l.borrowers[0];
                    const c = contacts[pri.cid];
                    if ( c && viewing.includes( c.aid ) ) {
                        list.push( {
                            ...l,
                            referredById: ( c && c.referredById ) ? c.referredById : null,
                            loanSource: ( l ) ? l.source : null,
                            loanStage: ( l ) ? l.stage : null,
                            rank: ( c && c.rank ) ? c.rank : null,
                        } );
                    }
                }
            } );
            list.sort( ( a, b ) => {
                let ad = new Date( a.pqDate || a.createdDate );
                let bd = new Date( b.pqDate || b.createdDate );
                return bd.getTime() - ad.getTime();
            } );
            setPAs( list );
            setLoading( false );
            setDirty( true );
        }
    }, [ status, loans, contacts, viewing ] );

    useEffect( () => {
        if ( !dirty ) {
            return;
        }

        const noteBucket = [];
        const taskBucket = [];
        const list = [];

        Object.keys( notes ).forEach( nid => {
            const n = notes[nid];
            if ( viewing.includes( n.aid ) ) {
                noteBucket.push( n );
            }
        } );
        Object.keys( tasks ).forEach( tid => {
            const t = tasks[tid];
            if ( viewing.includes( t.aid ) ) {
                taskBucket.push( t );
            }
        } );

        for ( const l of pa ) {
            const pri = l.borrowers.find( b => b.label === 'Primary' ) || l.borrowers[0];
            const c = contacts[pri?.cid];
            if ( c ) {
                const tmpNotes = [];
                const tmpTasks = [];

                for ( const n of noteBucket ) {
                    const yes = n.assoc?.find( f => f.cid === c.cid || f.lid === l.lid );
                    if ( yes ) {
                        tmpNotes.push( n );
                    }
                }
                tmpNotes.sort( ( a, b ) => {
                    const ad = new Date( a.createdDate );
                    const bd = new Date( b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );

                for ( const t of taskBucket ) {
                    if ( t.status !== 'Completed' ) {
                        continue;
                    }
                    const yes = t.assoc?.find( f => f.cid === c.cid || f.lid === l.lid );
                    if ( yes ) {
                        tmpTasks.push( t );
                    }
                }
                tmpTasks.sort( ( a, b ) => {
                    const ad = new Date( a.completedDate || a.createdDate );
                    const bd = new Date( b.completedDate || b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );

                list.push( {
                    ...c,
                    ...l,
                    lastTask: tmpTasks[0],
                    lastNote: tmpNotes[0],
                } );
            }
        }
        setPAs( list );
        setDirty( false );
    }, [ dirty, pa, contacts, notes, tasks, viewing ] );

    useEffect( () => {
        if ( pa.length > 0 ) {
            const today = new Date();
            const dayInMilli = 1000 * 60 * 60 * 24;
            
            let totalDays = 0;
            let totalVolume = 0;
            pa.forEach( l => {
                const pqDate = new Date( l.pqDate || l.statusChangeDate );
                totalDays += ( today.getTime() - pqDate.getTime() ) / dayInMilli;
                
                let maxPrice = l.paMaxPurchPrice || l.maxPurchPrice || l.highPurchPrice || l.lowPurchPrice || l.purchasePrice || l.amount;
                if ( maxPrice ) {
                    if ( typeof( maxPrice ) === 'string' ) {
                        maxPrice = maxPrice.replace( '$', '' );
                        maxPrice = maxPrice.replace( /,/g, '' );
                        maxPrice = maxPrice.replace( /\.\d\d/, '' );
                        maxPrice = Number( maxPrice );
                    }
                    totalVolume += maxPrice;
                }
            } );
            const avgDaysAsProspect = ( totalDays / pa.length ).toFixed( 1 );

            let window = 180;
            let metrics;
            let nextStage;
            if ( conversionView === 'active' ) {
                metrics = conversionResults.active[window];
                nextStage = 'In-Process';
            } else {
                metrics = conversionResults.funded[window];
                nextStage = 'Funded';
            }
            const projectedMin = Math.round( pa.length * ( metrics.rate - variance ) );
            const projectedMax = Math.round( pa.length * ( metrics.rate + variance ) );
            const projectedConversions = `${projectedMin}-${projectedMax}`;
            
            // Calculate stuck prospects (prospects that have been in stage for more than 30 days)
            const stuckProspects = pa.filter( l => {
                const paDate = new Date( l.prospectDate || l.statusChangeDate || l.createdDate );
                const daysInStage = ( today.getTime() - paDate.getTime() ) / ( 1000 * 60 * 60 * 24 );
                return daysInStage > 30;
            } ).length;

            setPipelineMetrics( [
                { label: 'Current Pre-Quals', value: pa.length, tooltip: 'Current # of Pre-Quals', icon: <FaUserFriends style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time as PQ', value: avgDaysAsProspect + ' days', tooltip: 'Average number of days pre-quals have been in this stage', icon: <FaClock style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Potential Volume', value: formatShorthand( totalVolume, 2 ), tooltip: 'Potential purchase volume of all pre-quals', icon: <FaDollarSign style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            setConversionMetrics( [
                { label: `Conversion to ${nextStage}`, value: ( metrics.rate * 100 ).toFixed( 1 ) + '%', tooltip: `Percentage of pre-quals from the past ${window} days that moved to ${nextStage}`, icon: <FaChartLine style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time to Convert', value: ( metrics.avgTimeToConvert ).toFixed( 1 ) + ' days', tooltip: `Average time it took to successfully convert a pre-qual to ${nextStage} (past ${window} days)`, icon: <FaCalendarAlt style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Projected Conversions', value: projectedConversions, tooltip: `Expected conversion range based on a ${( metrics.rate * 100 ).toFixed( 1 )}% historical conversion rate (+/- ${( variance * 100 ).toFixed( 1 )}%)`, icon: <FaMagic style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            // setRiskMetrics( [
            //     { label: 'Stuck Prospects', value: stuckProspects, tooltip: 'Number of prospects that have been in this stage for more than 30 days', icon: <FaExclamationTriangle style={{ color: '#ff7a59', marginRight: 8 }} /> }
            // ] );
        } else {
            // Reset metrics when no prospects
            setPipelineMetrics( [
                { label: 'Current Pre-Quals', value: 0, tooltip: 'Current # of Pre-Quals', icon: <FaUserFriends style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time as PA', value: 0, tooltip: 'Average number of days pre-quals have been in this stage', icon: <FaClock style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Potential Volume', value: 0, tooltip: 'Potential purchase volume of all pre-quals', icon: <FaDollarSign style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            setConversionMetrics( [
                { label: 'Successful Conversion %', value: 0, tooltip: 'Percentage of pre-quals that moved to In-Process over the past 180 days', icon: <FaChartLine style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time to Convert', value: 0, tooltip: 'Average time it took to convert successful pre-quals (past 180 days)', icon: <FaCalendarAlt style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Projected Conversions', value: '0-0', tooltip: `Expected conversion range based on a X% historical conversion rate (+/- ${Math.round( variance * 100 )}%)`, icon: <FaMagic style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            // setRiskMetrics( [
            //     { label: 'Stuck Prospects', value: 0, tooltip: 'Number of prospects that have been in this stage for more than 30 days', icon: <FaExclamationTriangle style={{ color: '#ff7a59', marginRight: 8 }} /> }
            // ] );
        }
        console.log( 'done setting segment metrics' );
    }, [ pa, conversionResults, conversionView, variance ] );

    useEffect( () => {
        if ( loans ) {
            const bucket = [];
            
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( !viewing.includes( l.aid ) ) {
                    return;
                }
                if ( l.pqDate ) {
                    bucket.push( l );
                }
            } );

            const windows = [ 90, 180, 270 ];
            const today = new Date();
            const results = {
                active: {},
                funded: {}
            };
            for ( const window of windows ) {
                const start = new Date( today );
                start.setDate( start.getDate() - window );
                start.setHours( 0, 0, 0 );

                let totalPQs = 0;
                let activeSuccesses = 0;
                let fundingSuccesses = 0;
                let activeDurations = [];
                let fundingDurations = [];

                for ( const l of bucket ) {
                    const pd = new Date( l.pqDate );
                    if ( pd < start ) {
                        continue;
                    }

                    totalPQs++;

                    if ( l.contractReceivedDate || l.intentProceedDate || l.respaTriggeredDate ) {
                        activeSuccesses++;
                        const duration = new Date( l.contractReceivedDate || l.intentProceedDate || l.respaTriggeredDate ) - pd;
                        activeDurations.push( duration );
                    }

                    if ( l.fundedDate ) {
                        fundingSuccesses++;
                        const duration = new Date( l.fundedDate ) - pd;
                        fundingDurations.push( duration );
                    }
                }

                results.active[window] = {
                    total: totalPQs,
                    successful: activeSuccesses,
                    rate: activeSuccesses / totalPQs || 0,
                    avgTimeToConvert: activeDurations.length ? activeDurations.reduce( ( a, b ) => a + b, 0 ) / activeDurations.length / ( 1000 * 60 * 60 * 24 ) : 0,
                };

                results.funded[window] = {
                    total: totalPQs,
                    successful: fundingSuccesses,
                    rate: fundingSuccesses / totalPQs || 0,
                    avgTimeToConvert: fundingDurations.length ? fundingDurations.reduce( ( a, b ) => a + b, 0 ) / fundingDurations.length / ( 1000 * 60 * 60 * 24 ) : 0,
                };
            }
            console.log( 'results', results );
            setConversionResults( results );
        }
    }, [ loans, viewing ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );
    
    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Pre-Qual'd Borrowers</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Card.Subtitle className='py-3' ref={numbersRef}>
                                <Row className='text-center'>
                                    <Col>
                                        <Box display="flex" gap={2} justifyContent="space-evenly" sx={ { flexDirection: { xs: 'column', md: 'row' } } }>
                                            <Card variant="outlined" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', px: 2 }}>
                                            {
                                                pipelineMetrics.map( ( metric, idx ) => (
                                                    <TableMetric key={`pipelineMetric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( pipelineMetrics.length - 1 ) } />
                                                ) )
                                            }
                                            </Card>
                                            <Card variant="outlined" style={{  display: 'flex', flexDirection: 'row', alignItems: 'center', px: 2, position: 'relative', minHeight: 95 }}>
                                                <Box position="absolute" top={4} right={8}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                size="small"
                                                                checked={conversionView === 'funded'}
                                                                onChange={(e) => setConversionView(e.target.checked ? 'funded' : 'active')}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Funded"
                                                        labelPlacement="start"
                                                        sx={{ m: 0, typography: 'caption', color: 'text.secondary', '& .MuiFormControlLabel-label': { fontSize: '0.55rem' } }}
                                                    />
                                                </Box>
                                            {
                                                conversionMetrics.map( ( metric, idx ) => (
                                                    <TableMetric key={`pipelineMetric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( conversionMetrics.length - 1 ) } />
                                                ) )
                                            }
                                            </Card>
                                            {/* <Card variant="outlined" style={{ border: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', px: 2 }}>
                                            {
                                                riskMetrics.map( ( metric, idx ) => (
                                                    <TableMetric key={`pipelineMetric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( riskMetrics.length - 1 ) } />
                                                ) )
                                            }
                                            </Card> */}
                                        </Box>
                                    </Col>
                                </Row>
                            </Card.Subtitle>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        { 
                                            ( gridReady ) ? (
                                                <DataGridPro
                                                    apiRef={gridRef}
                                                    initialState={ { 
                                                        // pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                                    } }
                                                    getRowId={ ( r ) => r.lid }
                                                    loading={ loading }
                                                    rows={ pa }
                                                    columns={ cols }
                                                    density='compact'
                                                    checkboxSelection
                                                    disableSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    onStateChange={ updateKPIs }
                                                />
                                            ) : (
                                                null
                                            )
                                        }
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    notes: state.notes.byId,
    tasks: state.tasks.byId,
    status: state.user.meta.loan.picklist.status
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( PQLoans );